var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-flex cart-timer"},[_c('div',{staticClass:"link"},[_c('i',{staticClass:"icon icon-android-alarm-clock"}),_vm._v(" "),_c('span',[_vm._v("\n          "+_vm._s(_vm.expiresInText)+"\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./Features/Shared/VueComponents/cart-timer.vue?vue&type=template&id=d7ef1e32&